import {Injectable} from '@angular/core';

import {AuthenticationService, TenantService} from './index';
import {LoginHelper} from '../helpers';
import {Subject} from "rxjs";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class ClientProfileService {
  updateList = new Subject();

  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  getClientProfiles(tenantName: string) {

    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/clientProfile/info/');
  }

  @Load()
  removeClientProfiles(id: number) {

    if (LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/clientProfile/' + id + '');

  }

  getClientProfile(id: number, tenantName: string) {

    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/clientProfile/info/' + id + '');
  }

  @Load()
  updateClientProfile(clientProfile: any) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/clientProfile/update', clientProfile);
  }

  /*
 updateClientProfile(clientProfile: ClientITProfile) {

      var tenantName = this.getTenantName();
      if (tenantName == null){
          this.authenticationService.logout();

          return null;
      }

      let formData = new FormData();

      //formData.append("ClientITProfile", JSON.stringify(clientProfile));
      //formData.append("ClientITProfile", JSON.stringify(clientProfile));
      formData.append("GeneralPurpose", clientProfile.generalPurpose);
      formData.append("TypesOfInformation", clientProfile.typesOfInformation);
      formData.append("SystemBoundaryDescription", clientProfile.systemBoundaryDescription);
      formData.append("SystemEnvironmentDescription", clientProfile.systemEnvironmentDescription);
      formData.append("ServerDescriptions", clientProfile.serverDescriptions);

      formData.append("ServerDiagramImage", clientProfile.serverDiagramImage);
      formData.append("SystemBoundaryDiagramImage", clientProfile.systemBoundaryDiagramImage);

      return this.http
          .post<any>(this.config.api + '/api/clientProfile/update', formData, this.jwt())
          ;
  }
  */

  @Load()
  uploadImageFile(diagram: File) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(diagram.name, diagram);

    return this.http
      .post<any>(this.config.api + '/api/clientProfile/image', formData);
  }

  @Load()
  uploadDiagram(diagram: File) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(diagram.name, diagram);

    return this.http
      .post<any>(this.config.api + '/api/clientProfile/diagram', formData);
  }

  @Load()
  populateDevices(diagram: File) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(diagram.name, diagram);

    return this.http
      .post<any>(this.config.api + '/api/clientProfile/devices', formData);
  }

  getSettings(tenantName: string) {
    return this.http.get<any>(this.config.api + '/api/settings?tenantName=' + tenantName);
  }
  getGlobalDevices() {
    return this.http.get<any>(this.config.api + '/api/clientProfile/device/info');
  }
  getPublicSettings(tenantName: string) {
    return this.http.get<any>(this.config.api + '/api/settings/public?tenantName=' + tenantName);
  }
  getMasterPublicSettings() {
    return this.http.get<any>(this.config.api + '/api/settings/master?tenantName=' + LoginHelper.getTenantNameFromUrl());
  }
  @Load()
  saveSettings(settings: any, tenantName: string) {
    return this.http.post<any>(this.config.api + '/api/settings', settings);
  }

  getUserSetting(key: string) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }
    return this.http.get<any>(this.config.api + '/api/setting?key=' + key);
  }

  saveUserSetting(key: string, settings: any) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }
    return this.http.post<any>(this.config.api + '/api/setting?key=' + key, settings);
  }

  getWorkstreams() {
    return this.http.get<any>(this.config.api + '/api/workstreams');
  }

  saveWorkstreamState(state: any) {
    return this.http.post<any>(this.config.api + '/api/workstreams', state);
  }

  getWorkstreamState(workstreamItemId: any, profileId: string) {
    return this.http.get<any>(this.config.api + '/api/workstream/' + workstreamItemId + '/state/' + profileId);
  }

  getWorkstreamControlItems(workstreamItemId: any) {
    return this.http.get<any>(this.config.api + '/api/workstream/' + workstreamItemId + '/controlItems');

  }

  getWorkstreamItem(workstreamItemId: number) {
    return this.http.get<any>(this.config.api + '/api/workstream/' + workstreamItemId);

  }
  uploadAttachment(diagram: File) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(diagram.name, diagram);

    return this.http
      .post<any>(this.config.api + '/api/clientProfile/uploadAttachment', formData);
  }
}
